import { createSlice } from "@reduxjs/toolkit";
import { QueryParams } from "@router/route-params";
import { getBooleanQueryParam } from "@utils/url-utils";

/** State for dev feature toggles */

/** Initial state for dev features slice */
export const initialDevFeaturesState = {
  isTranslationOverrideAllowed: getBooleanQueryParam(globalThis.location.search, QueryParams.allowTranslationOverride),
  isSentryEnabled: getBooleanQueryParam(globalThis.location.search, QueryParams.enableSentry),
  isProductFeedbackEnabled: getBooleanQueryParam(globalThis.location.search, QueryParams.enableProductFeedback)
};

/** Slice to manage dev features state */
const devFeaturesSlice = createSlice({
  name: "devFeatures",
  initialState: initialDevFeaturesState,
  reducers: {
    /** Sets whether translation override is allowed */
    setIsTranslationOverrideAllowed(state, action) {
      state.isTranslationOverrideAllowed = action.payload;
    },
    /** Sets whether Sentry errors should be sent from numbered environments or localhost */
    setIsSentryEnabled(state, action) {
      state.isSentryEnabled = action.payload;
    },
    /** Sets whether product feedback should be sent to Teams from non-production environments or localhost */
    setIsProductFeedbackEnabled(state, action) {
      state.isProductFeedbackEnabled = action.payload;
    },
    /** Resets the dev features state to its initial values */
    resetDevFeaturesState: () => initialDevFeaturesState
  }
});
export const {
  setIsTranslationOverrideAllowed,
  setIsSentryEnabled,
  setIsProductFeedbackEnabled,
  resetDevFeaturesState
} = devFeaturesSlice.actions;
export const devFeaturesReducer = devFeaturesSlice.reducer;